import PropTypes from 'prop-types';
import React from 'react';

import UnspecifiedValue from 'contest/components/brief/unspecified-value';

const ReadElementWrapper = ({ title, hasChanged, children }) => (
    <div className="brief-element">
        <h3 className="brief-element__title">
            {title}
            {hasChanged && <span className="dot dot--inline dot--offset-left" />}
        </h3>
        <div className="brief-element__value">{children}</div>
    </div>
);
ReadElementWrapper.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    hasChanged: PropTypes.bool.isRequired,
};

export const RawHtml = ({ html }) => <div dangerouslySetInnerHTML={{ __html: html }} />;
RawHtml.propTypes = {
    html: PropTypes.string.isRequired,
};

const connectReadElement = (
    ReadElementComponent,
    elementProps = () => ({}),
    hasValue = element => element.value
) => {
    const ConnectedReadElement = ({ element, hasChanged }) => (
        <ReadElementWrapper title={element.trans.title} hasChanged={hasChanged}>
            {hasValue(element) ? (
                <ReadElementComponent element={element} {...elementProps(element)} />
            ) : (
                <UnspecifiedValue message={element.trans.unspecifiedMessage} />
            )}
        </ReadElementWrapper>
    );
    ConnectedReadElement.propTypes = {
        element: PropTypes.object.isRequired,
        hasChanged: PropTypes.bool.isRequired,
    };
    return ConnectedReadElement;
};

export { ReadElementWrapper, connectReadElement };



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/read-element.jsx